import { Injectable } from '@angular/core';
import { User, CreateUserResponse } from '../models/ui/User';
import { APISettings } from '../misc/settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChangePasswordParameters, ResetPasswordParameters, ResetPasswordResponse, ChangePasswordResponse } from '../models/ui/ChangePasswordParameters';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  resetPassword(resetPassword: ResetPasswordParameters): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/user/resetpassword`,
    resetPassword, APISettings.httpOptions);
  }

  changePassword(changePassword: ChangePasswordParameters): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/user/changepassword`,
    changePassword, APISettings.httpOptions);
  }
  
  createUser(user: User): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/user/create`,
    user, APISettings.httpOptions);
  }

  updateUser(user: User): Observable<string>{
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/user/update`,
    user, APISettings.httpOptions);
  }

  updateUserRole(user: User): Observable<string>{
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/user/updaterole`,
    user, APISettings.httpOptions);
  }

  updateUserData(user: User): Observable<string>{
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/user/updatedata`,
    user, APISettings.httpOptions);
  }

  activateUser(user: User): Observable<string>{
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/user/activate`,
    user, APISettings.httpOptions);
  }

  unlockUser(user: User): Observable<string>{
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/user/unlock`,
    user, APISettings.httpOptions);
  }

  lockUser(user: User): Observable<string>{
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/user/lock`,
    user, APISettings.httpOptions);
  }

  deactivateUser(user: User): Observable<string>{
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/user/deactivate`,
    user, APISettings.httpOptions);
  }
}